import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "./CancelForm.css";
import { errorMessageStyle } from "../../../ui-elements/formStyles/formStyle";
import { primaryFIxed } from "../../../ui-elements/button";
import { validationSchema } from "./validation/validationSchema";
import {
  cancelPendingServiceOrder,
  getPendingService,
} from "../../../axios/api/PendingServiceApi";
import { useDispatch, useSelector } from "react-redux";
import {
  changePopUpStatus,
  setRequestStatus,
} from "../../../redux/slices/popUp/popUpSlice";
import {
  selectPendingServiceOrderId,
  setPendingServiceData,
} from "../../../redux/slices/pendingService/pendingServiceSlice";

const CancelForm = ({ setShowModal }) => {
  const { t } = useTranslation();
  const [selectedReason, setSelectedReason] = useState("");
  const pendeingServiceOrderId = useSelector(selectPendingServiceOrderId);
  const dispatch = useDispatch();

  const initVal = { reason: selectedReason, info: "" };

  const handleSubmit = async (val) => {
    const res = await cancelPendingServiceOrder({
      ...val,
      orderId: pendeingServiceOrderId,
    });
    if (res && res.data) {
      setShowModal(false);

      dispatch(changePopUpStatus(true));
      dispatch(setRequestStatus(res.data));

      const updatePendingService = await getPendingService();
      if (updatePendingService?.data) {
        dispatch(setPendingServiceData(updatePendingService.data));
      }
    }
  };

  const handleRadioClick = (value) => {
    if (selectedReason === value) {
      setSelectedReason("");
    } else {
      setSelectedReason(value);
    }
  };

  return (
    <Formik
      initialValues={initVal}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      <Form className="flex flex-col items-center md:mb-4 lg:mb-0">
        <div
          role="group"
          aria-labelledby="my-radio-group"
          className="flex flex-col justify-center items-center pl-6 md:pl-0 w-[95%] md:w-[75%]"
        >
          <label className="w-full h-[52px] prose-t16_regular flex items-center  gap-3 text-secondary_black dark:text-white">
            <Field
              type="radio"
              name="reason"
              value={t("changeOfPlans")}
              className="w-5 h-5"
              onClick={() => handleRadioClick("Reason 1")}
              checked={selectedReason === "Reason 1"}
            />
            {t("changeOfPlans")}
          </label>
          <label className="w-full h-[52px] prose-t16_regular flex items-center  gap-3 text-secondary_black dark:text-white">
            <Field
              type="radio"
              name="reason"
              value={t("foundAnotherProvider")}
              className="w-5 h-5"
              onClick={() => handleRadioClick("Reason 2")}
              checked={selectedReason === "Reason 2"}
            />
            {t("foundAnotherProvider")}
          </label>
          <label className="w-full h-[52px] prose-t16_regular flex items-center  gap-3 text-secondary_black dark:text-white">
            <Field
              type="radio"
              name="reason"
              value={t("serviceNotNeededAnymore")}
              className="w-5 h-5"
              onClick={() => handleRadioClick("Reason 3")}
              checked={selectedReason === "Reason 3"}
            />
            {t("serviceNotNeededAnymore")}
          </label>
          <label className="w-full h-[52px] prose-t16_regular flex items-center  gap-3 text-secondary_black dark:text-white">
            <Field
              type="radio"
              name="reason"
              value={t("other")}
              className="w-5 h-5"
              onClick={() => handleRadioClick("Reason 4")}
              checked={selectedReason === "Reason 4"}
            />
            {t("other")}
          </label>
        </div>
        <div className="mb-5 flex flex-col justify-center w-[80%]">
          <div className="flex flex-col relative">
            <Field
              as="textarea"
              name="info"
              placeholder={t("additionalInformation")}
              style={{ resize: "none" }}
              className="w-full h-[179px] md:w-[420px] md:h-[130px] bg-a05  dark:bg-[#262626] rounded-xl p-3 focus:outline-none"
            />
          </div>
          <ErrorMessage
            name="info"
            component="div"
            className={errorMessageStyle}
          />
        </div>
        <button type="submit" className={primaryFIxed}>
          {t("confirm")}
        </button>
      </Form>
    </Formik>
  );
};

export default CancelForm;
